import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewTaskFileGroupFilesService } from './review-task-file-group-files/review-task-file-group-files.service';
import { CancelTaskFileGroupFilesReviewService } from './cancel-task-file-group-files-review/cancel-task-file-group-files-review.service';
import { MoveTaskFilesToFileGroupService } from './move-task-files-to-file-group/move-task-files-to-file-group.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    ReviewTaskFileGroupFilesService,
    CancelTaskFileGroupFilesReviewService,
    MoveTaskFilesToFileGroupService
  ],
})
export class TaskFileGroupsModule {}
